import { IconProps } from "interfaces/icons";
import calculateSideByRatio from "utils/calculateSideByRatio";

const SIDES_RATIO = 1;

const ReservationIcon = ({ size, color }: IconProps): JSX.Element => {
	let height = 30;

	if (size) {
		height = size;
	}
	const width = calculateSideByRatio(height, SIDES_RATIO);

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 30 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0)">
				<path
					d="M25.9048 13.284V4.81899C25.9048 3.35834 24.6102 2.32926 23.1496 2.32926H20.9254V0.536749C20.9652 0.283163 20.7919 0.0453989 20.5383 0.00562324C20.4906 -0.00187441 20.442 -0.00187441 20.3943 0.00562324H17.2407C16.8755 0.00562324 16.6099 0.171588 16.6099 0.536749V2.32932H9.30682V0.536749C9.30682 0.171588 8.87526 0.00562324 8.5101 0.00562324H5.35645C4.99129 0.00562324 4.65936 0.171588 4.65936 0.536749V2.32932H2.63442C1.17378 2.32932 0.0119629 3.35841 0.0119629 4.81905V24.0728C0.0119629 25.5334 1.17384 26.5625 2.63442 26.5625H13.7219C16.8654 30.5043 22.6092 31.1515 26.551 28.008C28.7097 26.2865 29.9733 23.6803 29.988 20.9192C29.9342 17.8655 28.4147 15.0242 25.9048 13.284ZM17.9378 1.33341H19.5976V4.32103H17.9378V1.33341ZM5.98721 1.33341H7.97898V4.32103H5.98721V1.33341ZM1.33975 4.81899C1.33975 4.08866 1.9041 3.6571 2.63442 3.6571H4.65936V4.91855C4.67467 5.30284 4.97337 5.61571 5.35645 5.64887H8.5101C8.91409 5.62244 9.24538 5.31872 9.30682 4.91855V3.65717H16.61V4.91862C16.5905 5.29172 16.8687 5.61386 17.2407 5.64894H20.3944C20.7595 5.64894 20.9255 5.28378 20.9255 4.91862V3.65717H23.1496C23.88 3.65717 24.5771 4.08873 24.5771 4.81905V8.96855H1.33975V4.81899ZM2.63442 25.2346C1.9041 25.2346 1.33975 24.8031 1.33975 24.0728V10.2963H24.577V12.5869C23.4107 12.0891 22.16 11.8187 20.8922 11.7901C15.8504 11.7962 11.7682 15.8883 11.7743 20.9301C11.7762 22.4323 12.1486 23.9108 12.8587 25.2346H2.63442V25.2346ZM20.8259 28.687C16.5175 28.7053 13.01 25.2275 12.9917 20.9191C12.9734 16.6108 16.4513 13.1033 20.7596 13.085C25.068 13.0667 28.5755 16.5445 28.5938 20.8528C28.5938 20.8749 28.5938 20.897 28.5938 20.9191C28.5938 25.2092 25.1159 28.687 20.8259 28.687Z"
					fill={color}
				/>
				<path
					d="M23.9464 20.9192H20.9255V16.9357C20.9255 16.569 20.6283 16.2717 20.2616 16.2717C19.8949 16.2717 19.5977 16.569 19.5977 16.9357V21.5831C19.6631 21.9706 20.0014 22.2525 20.3944 22.247H23.9464C24.313 22.247 24.6103 21.9498 24.6103 21.5831C24.6103 21.2164 24.313 20.9192 23.9464 20.9192Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0">
					<rect width="30" height="30" fill={color} />
				</clipPath>
			</defs>
		</svg>
	);
};

export default ReservationIcon;
